import Image from "next/image"

const LeaderBoardError = () => {
    return (
        <div className="flex flex-col items-center gap-4 my-16">
            <Image
                src="/assets/img/icons/coming-soon.svg"
                alt="Error"
                width={128}
                height={128}
                className="w-56 h-56 mx-auto"
            />

            <h6 className="mt-4 text-lg font-semibold text-gray-600">
                Something went wrong
            </h6>
        </div>
    )
}

export default LeaderBoardError
